import React, { Component } from "react";
import { connect } from "react-redux";
import { resetCart } from "../../actions/cart";

class Cart extends Component {
  state = {
    cartItemsCount: 5
  };

  componentDidMount = () => {
    if (this.props.cart) {
      let cartItemsCount = this.props.cart.count;
      this.setState({ cartItemsCount });
    }
  };

  componentWillUpdate = props => {
    if (props.cart.count !== this.state.cartItemsCount) {
      let cartItemsCount = props.cart.count;
      this.setState({ cartItemsCount });
    }
  };

  resetCartCount = () => {
    this.props.resetCart();
  };

  render() {
    const count = this.state.cartItemsCount;
    return (
      <div className="cart" onClick={this.resetCartCount}>
          <div className="cart-count cart-count-mb">0</div>


        <img src="/images/cart.svg" width="37" alt="Cart" />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  cart: state.cart
});

const mapDispatchToProps = dispatch => ({
  resetCart: () => dispatch(resetCart())
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cart);
